if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.slick-dots li button').wrapInner('<span>');

    $('.js-terms').click(function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $(target).slideToggle();
    });

    //filters
    let tags = [],
        type = null,
        feature = null,
        bed = null;
    $('#room-type,#features,#beds').change(function(){
        var filter_index = 0;
        const selection = $(this).val(),
	          nameId = $(this).attr('id');

        if(nameId=='room-type'){
            const index = tags.indexOf(type);
            if (index > -1) 
                tags.splice(index, 1);
            type = selection
        }else if(nameId == 'features'){
            const index = tags.indexOf(feature);
            if (index > -1) 
                tags.splice(index, 1);
            feature = selection
        }else if(nameId == 'beds'){
            const index = tags.indexOf(bed);
            if (index > -1) 
                tags.splice(index, 1);
            bed = selection
        }
        
        tags.push(selection);
        tags = [...new Set(tags)];
        const items = $('section.quad');
        if(items.length>0){
            items.hide();
            items.filter((i,item)=>{
                item.classList.remove("even");
                var added = false;
                tags.forEach((tag)=>{
                    if($(item).data('tag').indexOf(tag)>-1){
                        added = true;
                    }    
                })
                if(added){
                    $(item).show();
                    if(filter_index%2==0){
                        item.classList.add("even");
                    }    
                    filter_index++;
                }
            })

            //$('html,body').animate({scrollTop: $('.rooms-block').offset().top+100},'slow');
        }
        
    });

})();